export const allowedExtensions = ['.png', '.jpeg', '.jpg'];
